module.exports = __webpack_public_path__ + "static/media/back-arrow.68b14b9e.svg";